import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { WallboxSelectStyled } from '../WallboxSelectStyled';
import { rem } from 'polished';

export const WallboxSelectAP = styled(WallboxSelectStyled)`
   
`;
